import type { PHDocumentEditorConfig } from "@powerhousedao/reactor-browser";

export const editorConfig: PHDocumentEditorConfig = {
  isExternalControlsEnabled: false,
};
